import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';
import { BinningModalComponent, BinningModalData } from './binning-modal.component';

@Injectable()
export class BinningModalService {
  constructor(private dialogService: DialogService) {}

  public open(data: BinningModalData): void {
    this.dialogService.open({
      component: BinningModalComponent,
      matDialogConfig: {
        backdropClass: 'mode-binning-modal-backdrop',
        data,
      },
    });
  }
}
